import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { User } from '../../auth/user.model';
import { Order } from '../../order/order.model';
import { ActivatedRoute, Router } from '@angular/router';
import { OrderService } from '../../order/order.service';
import { Subscription } from 'rxjs/index';
import { UIService } from '../../shared/ui.service';
import { AuthService } from '../../auth/auth.service';
import { MatSort, MatTableDataSource } from '@angular/material';
import { StorageService } from '../../storage/storage.service';

@Component({
  selector: 'app-order-invoice-list',
  templateUrl: './order-invoice-list.component.html',
  styleUrls: ['./order-invoice-list.component.css']
})
export class OrderInvoiceListComponent implements OnInit, OnDestroy, AfterViewInit {

  user: User;
  order: Order;
  isLoading = false;

  currentLanguage = 'en';

  displayedColumns: string[] = ['id', 'deliveryDate', 'category', 'amount', 'credit', 'paid', 'detail'];
  dataSource = new MatTableDataSource();

  @ViewChild(MatSort) sort: MatSort;

  private loadingSubscription: Subscription;
  private selectedProjectSubscription: Subscription;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private orderService: OrderService,
    private authentication: AuthService,
    private uiService: UIService,
    private _ref: ChangeDetectorRef,
    private localStorage: StorageService
  ) { }

  ngOnInit() {

    this.currentLanguage = this.localStorage.getPreferredLanguage();

    this.loadingSubscription = this.uiService.loadingStateChanged.subscribe(isLoading => {
      this.isLoading = isLoading;
      this._ref.markForCheck();
    });

    this.selectedProjectSubscription = this.uiService.selectedProjectChanged.subscribe(projectId => {
      this.router.navigate(['/invoices']);
    });

    this.user = this.authentication.getUser();
    this.route.paramMap.subscribe(params => {
      const id = params.get('id');
      this.orderService.getOrdersByIdV2(this.user.token, id).subscribe((result: Order) => {
        this.order = result;
        this.uiService.loadingStateChanged.next(false);
        for (const invoice of this.order.invoices) {
          if (invoice['transaction_id'] != null && String(invoice['transaction_id']) !== '') {
            invoice['is_paid'] = true;
          } else {
            invoice['is_paid'] = false;
          }
          if (invoice.category.is_refund === true) {
            invoice['credit'] = invoice.price;
          } else {
            invoice['amount'] = invoice.price;
          }
        }
        this.dataSource = new MatTableDataSource(this.order.invoices);
      });
    });
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
  }

  ngOnDestroy() {
    this.loadingSubscription.unsubscribe();
    this.selectedProjectSubscription.unsubscribe();
  }


  downloadPDF(invoice){
    this.orderService.getInvoicePDF(this.user.token, invoice).subscribe((res: any) => {
        console.log(res);
      },(error: Error) => {
          if(error ){
            console.log(error);
      }});
  }

}
